let Universal = { x: null, y: null };
let last_content = "";
function closeZoom() {
  let container = document.querySelector(".product-grid");
  if (!container) {
    return false;
  }
  container.classList.remove("zoom-actived");
  let html = document.querySelector("html");
  html.classList.remove("scroll-hidden");

  document.querySelectorAll(".my-zoom-img").forEach(function (img) {
    img.remove();
  });

  Universal.x = null;
  Universal.y = null;
  document.querySelector("#portada").classList.remove("zoom-actived");
  setTimeout(function () {
    document.querySelector("#portada").classList.remove("zoom-actived");
  }, 100);
}
function zoomIn(e) {
  var img = e.target;
  var element = document.querySelector("#overlay");
  if (!img) {
    return false;
  }
  if (!element) {
    return false;
  }
  if (img.tagName == "IMG") {
    element.style.backgroundImage = "url(" + img.src + ")";
  }
  document.querySelector("#portada").classList.add("zoom-actived");
  element.style.display = "inline-block";

  var posX = e.offsetX ? e.offsetX : e.pageX - img.offsetLeft;
  var posY = e.offsetY ? e.offsetY : e.pageY - img.offsetTop;

  var clientH = img.clientHeight;
  var clientW = img.clientWidth;

  var totalSize = clientW * 0.25 * -1;
  element.style.width = clientW + "px";
  element.style.height = clientH + "px";
  element.style.left = img.offsetLeft + "px";
  element.style.top = img.offsetTop + "px";

  var totalX = -posX - totalSize;
  var totalY = -posY - totalSize;

  element.style.backgroundPosition = totalX + "px " + totalY + "px";
}
function zoomOut(e) {
  document.querySelector("#portada").classList.remove("zoom-actived");
  var element = document.querySelector("#overlay");
  element.style.display = "none";
}
function add_zoom_events() {
  document.querySelectorAll(".product-image-slider img[data-src]").forEach(function (img) {
    img.draggable = false;
    if (img.dataset.src.search(".gif") >= 0) {
      /*no delete this*/
    } else {
      img.addEventListener("mousemove", zoomIn);
      img.addEventListener("mouseout", zoomOut);
      img.addEventListener("touchstart", function (e) {
        let element = e.target;
        if (element.tagName != "IMG") {
          return false;
        }
        let container = document.querySelector(".product-grid");
        if (!container) {
          return false;
        }

        document.querySelectorAll(".my-zoom-img").forEach(function (img) {
          img.remove();
        });

        let img = document.createElement("img");
        img.src = element.src;
        img.classList.add("my-zoom-img");

        container.prepend(img);
        container.classList.add("zoom-actived");

        let html = document.querySelector("html");
        html.classList.add("scroll-hidden");
      });
      img.addEventListener("touchmove", function (e) {
        img = e.target;
        if (img.tagName == "IMG") {
          let touch = e.touches[0];
          let x = touch.pageX;
          let y = touch.pageY;

          let zoom = document.querySelector(".my-zoom-img");

          let screemW = (window.innerWidth / 2) * -1;
          let screemH = (window.innerHeight / 2) * -1;

          let totalX = x + screemW;
          let TotalY = y + screemH;

          zoom.style.left = totalX + "px";
          zoom.style.top = TotalY + "px";
        }
      });
      img.addEventListener("touchend", closeZoom);
    }
  });
  window.addEventListener("touchend", closeZoom);
  document.querySelectorAll(".my-zoom-img").forEach(function (img) {
    img.addEventListener("contextmenu", (e) => {
      e.preventDefault();
      return false;
    });
  });
}
function loadProductPage(selector) {
  var variantDropdownSelector =
    ".meroda-variant-dropdown > select, .meroda-variant-dropdown > .dd-container";
  
  // Product slider
  selector.find(".product-image-slider-container .product-image-slider").slick({
    asNavFor: selector.find(".product-image-slider-container .product-image-slider-control"),
    variableHeight: false,
    prevArrow: false,
    nextArrow: false,
    infinite: false,
    loop: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          dots: false,
        },
      },
    ],
  });

  selector.find(".product-image-slider-container .product-image-slider-control").slick({
    asNavFor: selector.find(".product-image-slider-container .product-image-slider"),
    centerPadding: '0px',
    vertical: true,
    arrows: false,
    infinite: false,
    centerMode: true,
    slidesToShow: 4,
    focusOnSelect: true,
  });

  function variantChanged(variantId) {
    // Filter slider
    updateQueryString("variant", variantId);
    add_zoom_events();
    let btn = document.querySelector(".meroda-atc-btn");
    let sticky = document.querySelector(".sticky-cart-button");
    if (btn && sticky) {
      let variant;
      for (v in productNow.variants) {
        variant = productNow.variants[v];
        if (variant.id == variantId) {
          if (variant.available) {
            btn.disabled = false;
            if (typeof btn.dataset.text) {
              btn.innerText = "AGGIUNGI AL CARRELLO";
            }
            sticky.style.display = "inherit";
          } else {
            btn.disabled = true;
            btn.innerText = "UITVERKOCHT";
            console.clear();
            sticky.style.display = "none";
          }
          break;
        }
      }
    }
    selector
      .find(".product-image-slider-container .product-image-slider")
      .slick("slickUnfilter")
      .slick(
        "slickFilter",
        "[data-variant-id='" + variantId + "'], .product-image-slide:not([data-variant-id])"
      )
      .slick("goTo", 0);

    selector
      .find(".product-image-slider-container .product-image-slider-control")
      .slick("slickUnfilter")
      .slick(
        "slickFilter",
        "[data-variant-id='" +
          variantId +
          "'], .product-image-slider-thumbnail:not([data-variant-id])"
      )
      .slick("goTo", 0);

    // Update YMK
    if (typeof window.YMK !== "undefined" && window.YMK) {
      if (window.YMK.isLoaded()) {
        window.YMK.applyMakeupBySku("sku-" + variantId);
      }
    }
    // Update Benefits section video
    if (document.querySelector('.js-variant-video-container video') && window._variantsVideo[`${ variantId }`] != undefined) {
      document.querySelector('.js-variant-video-container video').src = window._variantsVideo[`${ variantId }`];
    }
    // Update Ingrediets drawer text
    if (document.querySelector('.js-variant-content-container') && window._variantsIngredients[`${ variantId }`] != undefined) {
      document.querySelector('.js-variant-content-container').innerText = window._variantsIngredients[`${ variantId }`];
    }
  }

  function fixSlickFilterWithFocusOnSelect(elem) {
    // https://github.com/kenwheeler/slick/issues/1043
    var oldReinit = elem.slick("getSlick").reinit;
    var newReinit = function reinitOverride() {
      this._overriddenReinit();
      this.$slides.each(function (index, element) {
        $(element).attr("data-slick-index", index);
      });
    };

    elem.slick("getSlick")._overriddenReinit = oldReinit;
    elem.slick("getSlick").reinit = newReinit;
  }

  fixSlickFilterWithFocusOnSelect(
    selector.find(".product-image-slider-container .product-image-slider")
  );
  fixSlickFilterWithFocusOnSelect(
    selector.find(".product-image-slider-container .product-image-slider-control")
  );

  selector.find(variantDropdownSelector).ddslick({
    height: 240,
    background: "#ffffff",
    onSelected: function (selectedData) {
      selector.find("input.meroda-selected-variant-input").val(selectedData.selectedData.value);
      selector.find("input.meroda-variantid-field").val(selectedData.selectedData.value);
      selector
        .find(
          "input[name=variant-color-blob][variantnumber=" + selectedData.selectedData.value + "]"
        )
        .prop("checked", true);
      selector
        .find(
          "input[name=variant-color-blob][variantnumber=" + selectedData.selectedData.value + "]"
        )
        .trigger("click");
      variantChanged(selectedData.selectedData.value);
    },
  });

  selector.find("input[type=radio][name=variant-color-blob]").change(function () {
    selector.find(variantDropdownSelector).ddslick("select", {
      index: this.value,
    });
  });

  selector.find("input[type=radio][class=input-color-bundle]").change(function (e) {
    e.target.closest(".product-page-bundle-tint-picker").querySelector(".bundle-variant-id").value =
      this.getAttribute("variantnumber");
    e.target
      .closest(".product-page-bundle-tint-picker")
      .querySelector(".variant-image-container img").src = this.getAttribute("imageURL");
  });

  selector.find("input[type=radio][class=input-color-bundle]").change(function (e) {
    e.target.closest(".product-page-bundle-tint-picker").querySelector(".bundle-variant-id").value =
      this.getAttribute("variantnumber");
    e.target
      .closest(".product-page-bundle-tint-picker")
      .querySelector(".checkmark-bundle-preview").style =
      "background-color:" + this.getAttribute("variantColor") + ";background-size:cover;";
  });

  selector.find("input[type=radio][class=input-color-bundle]").change(function (e) {
    e.target
      .closest(".product-page-bundle-tint-picker")
      .querySelector(".inner-variant-title-bundle").innerHTML = this.getAttribute("varianttitle");
  });

  selector.find("input[type=radio][class=input-color-bundle]").change(function (e) {
    const textBundle = e.target
      .closest(".product-page-bundle-tint-picker")
      .querySelector(".variant-name-text-bundle")

    if (textBundle) {
      textBundle.innerHTML =
      "| " + this.getAttribute("variantname");
    }
  });

  // Sets the opacity for the selected variant preview (if not available, 0.2 is setted)
  selector.find("input[type=radio][class=input-color-bundle]").change(function (e) {
    e.target
      .closest(".product-page-bundle-tint-picker")
      .querySelector(".checkmark-bundle-preview").style =
      "background-color:" +
      this.getAttribute("variantColor") +
      ";background-size:cover;opacity:" +
      this.getAttribute("opacity");

    //setting the "available" attribute equals to que variant "isAvailable attribute"
    e.target
      .closest(".product-page-bundle-tint-picker")
      .querySelector(".checkmark-bundle-preview")
      .setAttribute("available", this.getAttribute("isAvailable"));

    spans = document.querySelectorAll(".checkmark-bundle-preview");
    allAvailables = true;
    spans.forEach((e) => {
      if (e.getAttribute("available") == "not-available") {
        allAvailables = "not-available";
      }
    });

    // If variant is not available, this changes the styles and text of the ATC button
    selector.find(".meroda-atc-btn").attr("isAvailable", this.getAttribute("isAvailable"));
    if (allAvailables == "not-available") {
      selector.find(".meroda-atc-btn").html("Esaurito");
      selector.find(".meroda-atc-btn").attr("disabled", "");
      document
        .querySelector(".sticky-cart-button")
        .style.setProperty("display", "none", "important");
    } else {
      selector.find(".meroda-atc-btn").html("AGGIUNGI AL CARRELLO");
      selector.find(".meroda-atc-btn").removeAttr("disabled");
      document
        .querySelector(".sticky-cart-button")
        .style.setProperty("display", "none", "important");
    }
  });

  selector.find("input[type=radio][class=input-color-bundle]").change(function (e) {});

  add_zoom_events();
  let variant_description = document.querySelector(".product-variant-description");
  document.querySelectorAll("input[type=radio][name=variant-color-blob]").forEach(function (input) {
    let color = input.closest(".inputcontainer");
    let title_ = input.dataset.title;
    let description_ = input.dataset.description;

    if (color) {
      const setAdditionalVariantId = (event) =>{
        const additionalVariantId = event.currentTarget.getAttribute("data-additional-variant-id");
        
        additionalVariantId
          ? sessionStorage.setItem("additionalVariantId", additionalVariantId)
          : sessionStorage.removeItem("additionalVariantId");
      }
      color.addEventListener("click", setAdditionalVariantId);

      function showVariantBadge(variantId) {
        const badgeElements = document.querySelectorAll('.product-image-slider-container [data-variant-id-badge]');
        badgeElements.forEach(badgeElement => {
          const badgeVariantId = badgeElement.dataset.variantIdBadge;
          badgeVariantId === variantId ? badgeElement.classList.remove('hide') : badgeElement.classList.add('hide');
        });
      }

      color.addEventListener("mouseover", function () {
        let input = this.querySelector("[variantnumber]");
        if (!input) {
          return false;
        }
        variantId = input.getAttribute("variantnumber");

        selector
          .find(".product-image-slider-container .product-image-slider")
          .slick("slickUnfilter")
          .slick(
            "slickFilter",
            "[data-variant-id='" + variantId + "'], .product-image-slide:not([data-variant-id])"
          )
          .slick("goTo", 0);

        showVariantBadge(variantId);

        selector
          .find(".product-image-slider-container .product-image-slider-control")
          .slick("slickUnfilter")
          .slick(
            "slickFilter",
            "[data-variant-id='" +
              variantId +
              "'], .product-image-slider-thumbnail:not([data-variant-id])"
          )
          .slick("goTo", 0);
        if (variant_description) {
          variant_description.innerHTML =
            "<strong>Colore: </strong>" + title_ + " | " + description_;
        }
      });
      color.addEventListener("mouseout", function () {
        let parent = document.querySelector(
          ".inputcontainer input:checked ~ .checkmark"
        ).parentElement;
        let input = parent.querySelector("input");
        let variantId = input.getAttribute("variantnumber");

        input.click();
        selector
          .find(".product-image-slider-container .product-image-slider")
          .slick("slickUnfilter")
          .slick(
            "slickFilter",
            "[data-variant-id='" + variantId + "'], .product-image-slide:not([data-variant-id])"
          )
          .slick("goTo", 0);

        showVariantBadge(variantId);

        selector
          .find(".product-image-slider-container .product-image-slider-control")
          .slick("slickUnfilter")
          .slick(
            "slickFilter",
            "[data-variant-id='" +
              variantId +
              "'], .product-image-slider-thumbnail:not([data-variant-id])"
          )
          .slick("goTo", 0);
      });
    }
  });

  // Changes while hovering for BUNDLES

  let bundleItemsContainers = document.querySelectorAll(".product-page-bundle-tint-picker");
  bundleItemsContainers.forEach((e) => {
    e.querySelectorAll("input[type=radio][subname=variant-color-blob]").forEach(function (input) {
      let color = input.closest(".inputcontainer");
      let originalImage;
      let originalColor;
      let originalTitle;
      let originalName;
      if (color) {
        color.addEventListener("mouseover", function () {
          originalImage = e.querySelector(".variant-image-container img").src;
          originalColor = e.querySelector("span.checkmark-bundle-preview").style.backgroundColor;
          originalTitle = e.querySelector("div.inner-variant-title-bundle").innerText;
          originalName = e.querySelector("div.variant-name-text-bundle") ? e.querySelector("div.variant-name-text-bundle").innerText : '';
          e.querySelector(".variant-image-container img").src = input.getAttribute("imageurl");
          e.querySelector("span.checkmark-bundle-preview").style.opacity =
            input.getAttribute("opacity");
          e.querySelector("span.checkmark-bundle-preview").style.backgroundColor =
            input.getAttribute("variantcolor");
          e.querySelector("div.inner-variant-title-bundle").innerText =
            input.getAttribute("varianttitle");
          if (e.querySelector("div.variant-name-text-bundle")) {
            e.querySelector("div.variant-name-text-bundle").innerText = `| ${input.getAttribute(
              "variantname"
            )}`;
          }
        });
        color.addEventListener("mouseout", function () {
          if (
            e.querySelector(".variant-keeper-input").getAttribute("value") !=
            input.getAttribute("variantnumber")
          ) {
            e.querySelector(".variant-image-container img").src = originalImage;
            e.querySelector("span.checkmark-bundle-preview").style.backgroundColor = originalColor;
            e.querySelector("div.inner-variant-title-bundle").innerText = originalTitle;
            if (e.querySelector("div.variant-name-text-bundle")) {
              e.querySelector("div.variant-name-text-bundle").innerText = originalName;
            }
          }
        });
      }
    });
  });
  // END OF Changes while hovering for BUNDLES

  selector.find(".meroda-atc-btn").click(function (e) {
    e.preventDefault();
    selector.find(".shopify-product-form").addClass("js-ajax-cart-form-in-progress");

    if (e.target.classList.contains("bundle-atc-button") == false) {

      let variantId = selector.find(".meroda-selected-variant-input").val();

      if (selector.find('[name="id"][fixed-value]').length > 0) {
        variantId = selector.find('[name="id"][fixed-value]').attr('fixed-value')
      }

      const item = {
        id: variantId,
        quantity: 1,
      };

      const input = document.querySelector("#blackFridayInputVal");
      if (input) {
        const name = input
          .getAttribute("name")
          .replace(/^properties\[/, "")
          .replace(/\]$/, "");

        item.properties = { [name]: input.value };
      }

      var items = [item];

      console.log('----', items)

      // Also add to cart is checkbox is checked
      let extraProductCheckbox = selector.find(".extra-product-checkbox");
      if (extraProductCheckbox.is(":checked")) {
        let variantId = extraProductCheckbox.data("variant-id");
        items.push({
          id: variantId,
          quantity: 1,
        });
      }
    } else {
      let activeBundle = parseInt(e.target.dataset.bundleId);
      let properties = {};

      
      
      const foundBundleBelong = identifyBundle(activeBundle)

      if (foundBundleBelong) {
        properties["_bundles"] = foundBundleBelong
      }

      let fullVariantsOfBundle = [];
      let variantitas = document.querySelectorAll(".bundle-variant-id");
      for (let i = 0; i < variantitas.length; i++) {
        fullVariantsOfBundle.push(variantitas[i].getAttribute("value"));
      }

      function findQty(arr) {
        let quantities = [];
        let noRepeatedQty = [];
        arr.forEach((e) => {
          let qty = 1;
          for (let i = 0; i < arr.length; i++) {
            if (arr.indexOf(e) != i) {
              if (e == arr[i]) {
                qty += 1;
              }
            }
          }
          quantities.push(e + "-qty-" + qty);
        });
        function onlyUnique(value, index, self) {
          return self.indexOf(value) === index;
        }
        let unique = quantities.filter(onlyUnique);
        return unique;
      }

      // Setting up product properties
      properties["_isBundle"] = `${findQty(fullVariantsOfBundle)}`;
      // Title
      properties["_data-bundle-title"] = selector
        .find(".meroda-atc-btn.bundle-atc-button")
        .attr("data-bundle-title");
      // Image
      properties["_data-bundle-image"] = selector
        .find(".meroda-atc-btn.bundle-atc-button")
        .attr("data-bundle-image");
      // URL
      properties["_data-bundle-url"] = selector
        .find(".meroda-atc-btn.bundle-atc-button")
        .attr("data-bundle-url");

      // Price
      properties["_data-bundle-price"] = selector
        .find(".meroda-atc-btn.bundle-atc-button")
        .attr("data-bundle-price");

      // New Price
      properties["_data-bundle-new-price"] = selector
        .find(".meroda-atc-btn.bundle-atc-button")
        .attr("data-bundle-new-price");

      // BFCM Discount
      properties["_BFCM_Discount"] = selector
        .find(".meroda-atc-btn.bundle-atc-button")
        .attr("data-bundle-line-item-bfcm");
        
		if(document.querySelector('[data-gamification="b"]')){variant_status="b";}		
		properties["variant"]=variant_status;
      var items = [];
      selector.find(".bundle-variant-id").each(function () {
        let variantId = $(this).val();

        let foundId = false;
        items.forEach((item) => {
          if (item.id == variantId) {
            item.quantity += parseInt(selector.find(".quantity-selector-value").val());
            foundId = true;
          }
        });
        if (foundId == false) 
        {
          variant_status="a";
		  if(document.querySelector('[data-gamification="b"]')){variant_status="b";}
          properties.variant=variant_status;
          items.push({
            id: variantId,
            quantity: parseInt(selector.find(".quantity-selector-value").val()),
            properties: properties,
          });
        }
      });
    }

    const additionalVarId = sessionStorage.getItem("additionalVariantId");
    if(additionalVarId) items.push({id: additionalVarId, quantity: 1,});

    items.forEach(i => {
      if (window.abProperties && Object.keys(window.abProperties).length > 0) {
        i.properties = {...i.properties, ...window.abProperties}
      }

      return i
    })

    console.log(items);
    
    liquidAjaxCart.cartRequestAdd(
      {
        items: items,
      },
      {
        lastComplete: (requestState) => {
          selector.find(".shopify-product-form").removeClass("js-ajax-cart-form-in-progress");
        },
      }
    );
  });

  selector.find(".variants-range-dropdown").ddslick({
    height: 240,
    background: "#ffffff",
    onSelected: function (selectedData) {
      let value = selectedData.selectedData.value;

      selector.find("input.meroda-rangeid-field").val(value);

      // Hide all, then show correct ones later
      selector.find(".products-colors-container .inputcontainer[variantgroup]").hide();

      // Show correct shades
      if (value == "all") {
        // show all
        selector.find(".products-colors-container .inputcontainer[variantgroup]").show();
      } else {
        // only show for shade
        selector
          .find(".products-colors-container .inputcontainer[variantgroup='" + value + "']")
          .show();
      }
    },
  });
}

docReady(function () {
  loadProductPage($(".product-section"));
});